import styled, { css } from 'styled-components';

export const PaymentAccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 16px;
`;

export const RenewalInformation = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
    max-width: 545px;
    padding-top: 10px;
    span {
      font-weight: ${theme.v2.font.weights.medium};
    }
    a {
      font-size: ${theme.v2.font.sizes.xxs};
    }
    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: unset;
    }
  `}
`;
